/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  DropdownButton,
  MenuItem,
  Button,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { kGroupTimes } from '../../constants';
import styles from './styles.scss';

const propTypes = {
  onSelect: React.PropTypes.func.isRequired,
  onDelete: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  value: React.PropTypes.string.isRequired,
};

class GroupByTimeButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend.groupbytime');
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value });
    }
  }

  render() {
    const { onSelect, onDelete } = this.props;
    const { value } = this.state;
    return (
      <div className={styles.btnGroup}>
        <DropdownButton
          id="group-by"
          bsStyle="aisz-time"
          title={(
            <span>
              <i className="fa fa-clock-o" aria-hidden="true" />{' '}
              {this.intlMsg.msg(value)}
            </span>
          )}
          onSelect={onSelect}
          pullRight
        >
          {kGroupTimes.map(type => (
            <MenuItem key={type} eventKey={type}>
              <i className="fa fa-clock-o" aria-hidden="true" />{' '}
              {this.intlMsg.msg(type)}
            </MenuItem>
          ))}
        </DropdownButton>
        <Button
          bsStyle="aisz-time"
          className={styles.closeBtn}
          onClick={onDelete}
        >
          <i className="fa fa-times" />
        </Button>
      </div>
    );
  }
}

GroupByTimeButton.propTypes = propTypes;

export default injectIntl(GroupByTimeButton);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/coms/GroupByTimeButton/index.jsx